module.exports = __webpack_public_path__ + "static/img/projectcovermobile.b45a8eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Telll/projectcovermobile.png
// module id = u1SQ
// module chunks = 0